import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-newsletter-container',
  imports: [CommonModule,RouterModule],
  templateUrl: './newsletter-container.component.html',
  styleUrl: './newsletter-container.component.scss',
  standalone: true
})
export class NewsletterContainerComponent {

}
